import React from "react"
import { Pie } from "~/ui/progress"
import styled from '~/ui/styled'

interface Props {
  inProgress: boolean
  progress: number
  size?: number
}

const Overlay = styled.View`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 0.7;
  align-items: center;
  justify-content: center;
  z-index: 1;
`

// 加载进度条
const Progress: React.FC<Props> = ({ size = 50, inProgress, progress }) => {
  return inProgress ? (
    <Overlay>
      <Pie progress={progress} size={size} color={"black"} />
    </Overlay>
  ) : null
}

export default Progress
